import { render, staticRenderFns } from "./Product02.vue?vue&type=template&id=63008fa8&scoped=true&"
import script from "./Product02.vue?vue&type=script&lang=js&"
export * from "./Product02.vue?vue&type=script&lang=js&"
import style0 from "./Product02.vue?vue&type=style&index=0&id=63008fa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63008fa8",
  null
  
)

export default component.exports